const delivery_methods = {
  pickup: 'pickup',
  delivery: 'delivery',
  satellite_pickup: 'sattelite_pickup'
};

// day 0 = sunday day 6 = saturday
const third_party_time_windows = {
  0:
    { // sun 
    '8am-11am': 8,
    '9am-12pm': 9,
    '12pm-3pm': 12,
    '3pm-6pm': 15,
    '5pm-8pm': 17
  },
  1: { // mon
    '6am-9am':6,
    '7am-10am':7,
    '10am-1pm':10,
    '1pm-4pm':13,
    '4pm-7pm':16,
    '5pm-8pm':17
  },
  2: { // tue
    '6am-9am':6,
    '7am-10am':7,
    '10am-1pm':10,
    '1pm-4pm':13,
    '4pm-7pm':16,
    '5pm-8pm':17
  },
  3: { // wed
    '6am-9am':6,
    '7am-10am':7,
    '10am-1pm':10,
    '1pm-4pm':13,
    '4pm-7pm':16,
    '5pm-8pm':17
  },
  4: { // thu
    '6am-9am':6,
    '7am-10am':7,
    '10am-1pm':10,
    '1pm-4pm':13,
    '4pm-7pm':16,
    '5pm-8pm':17
  },
  5: { // fri
    '6am-9am':6,
    '7am-10am':7,
    '10am-1pm':10,
    '1pm-4pm':13,
    '3pm-6pm':15,
    '4pm-7pm':16,
  },
  6: { // sat
    '8am-11am':8,
    '9am-12pm':9,
    '10am-1pm':10,
    '1pm-4pm':13,
    '3pm-6pm':15,
    '4pm-7pm':16
  },
}


// modify the time of day cut off, local time

// pickup
const blockedDates2024 = [
  "2024-07-04", "2024-11-28", "2024-12-25",
  "2025-07-04", "2025-11-27", "2025-12-25",
  "2026-07-04", "2026-11-26", "2026-12-25",
  "2027-07-04", "2027-11-25", "2027-12-25",
  "2028-07-04", "2028-11-23", "2028-12-25",
];

// delivery
const overrideDeliveryBlockedOutDays = [
  "2024-07-04", "2024-11-28", "2024-12-25",
  "2025-07-04", "2025-11-27", "2025-12-25",
  "2026-07-04", "2026-11-26", "2026-12-25",
  "2027-07-04", "2027-11-25", "2027-12-25",
  "2028-07-04", "2028-11-23", "2028-12-25",
];

// add new locations
const deliveryLocByRegion = {
  // window.overrideDeliveryLocByRegion = {
  colorado: {
    region_name: 'Colorado',
    time_zone: 'America/Denver',
    time_zones: ['America/Denver', 'US/Mountain', 'US/Arizona', 'America/Boise', 'America/Phoenix'],

    // delivery cut off time
    pickupPreorderCutoff: [
      [19, 59], // sunday
      [19, 59], // monday
      [19, 59], // tues
      [19, 59], // weds
      [19, 59], // thurs
      [18, 59], // fri
      [18, 59], // sat
    ],

    // sdd cut off time
    // make sure THIS COINCIDES WITH 3rd PARTY TIME WINDOWS
    mffDeliveryCutoff: [
      [16, 59], // sunday
      [16, 59], // monday
      [16, 59], // tues
      [16, 59], // weds
      [16, 59], // thurs
      [15, 59], // fri
      [15, 59], // sat
    ],
   
    satellitePickupCalendarOffset: [
      2, // sun
      2, // mon
      5, // tues
      4, // weds
      3, // thurs
      2, // fri
      2  // sat
    ],


    mff_locs: [
      {
        id: 71, // not sure where this is relvant - from old school
        alias: 'mff-cherry-creek',
        name: 'My Fit Foods Cherry Creek',
        address: '201 University Blvd, Unit 108, Denver, CO 80206',
        hours: {
          Monday: "7am - 8pm",
          Tuesday: "7am - 8pm",
          Wednesday: "7am - 8pm",
          Thursday: "7am - 8pm",
          Friday: "7am - 7pm",
          Saturday: "8am - 7pm",
          Sunday: "8am - 8pm"
        }
      },
      {
        id: 2, // not sure where this is relvant - from old school
        alias: 'mff-denver',
        name: 'My Fit Foods Denver Tech Center',
        address: '8000 E Belleview Ave #D60, Greenwood Village, CO 80111',
        hours: {
          Monday: "7am - 8pm",
          Tuesday: "7am - 8pm",
          Wednesday: "7am - 8pm",
          Thursday: "7am - 8pm",
          Friday: "7am - 7pm",
          Saturday: "8am - 7pm",
          Sunday: "8am - 8pm"
        }
      },
      {
        id: 3, // not sure where this is relvant - from old school
        alias: 'mff-highlands',
        name: 'My Fit Foods Highlands',
        address: '3024 N Speer Blvd, Denver, CO 80211',
        hours: {
          Monday: "7am - 8pm",
          Tuesday: "7am - 8pm",
          Wednesday: "7am - 8pm",
          Thursday: "7am - 8pm",
          Friday: "7am - 7pm",
          Saturday: "8am - 7pm",
          Sunday: "8am - 8pm"
        }
      }
    ],

    gym_locs: [
      {
        alias: 'pickup-CF-Salvo',
        name: 'Crossfit Salvo',
        address: '975 Platte River Blvd, Brighton, CO 80601',
        hours: {
          Monday: "After 2pm",
          Tuesday: "After 2pm",
          Wednesday: "After 2pm"
        }
      },

    ],

    other_locs: [

    ],

  },


  oregon: {
    time_zone: 'America/Los_Angeles',
    time_zones: ['America/Los_Angeles', 'US/Pacific'],

    region_name: 'Oregon/Washington',

    // delivery cut off time
    pickupPreorderCutoff: [
      [19, 59], // sunday
      [19, 59], // monday
      [19, 59], // tues
      [19, 59], // weds
      [19, 59], // thurs
      [18, 59], // fri
      [18, 59], // sat
    ],

    // sdd cut off time
    // make sure THIS COINCIDES WITH 3rd PARTY TIME WINDOWS
    mffDeliveryCutoff: [
      [16, 59], // sunday
      [16, 59], // monday
      [16, 59], // tues
      [16, 59], // weds
      [16, 59], // thurs
      [15, 59], // fri
      [15, 59], // sat
    ],
    satellitePickupCalendarOffset: [
      2, // sun
      2, // mon
      5, // tues
      4, // weds
      3, // thurs
      2, // fri
      2  // sat
    ],

    mff_locs: [
      {
        id: 1, // not sure where this is relvant - from old school
        alias: 'mff-beaverton',
        name: 'My Fit Foods Progress Ridge',
        address: 'Progress Ridge Townsquare, 14985 SW Barrows Rd. #121, Beaverton, OR 97007',
        hours: {
          Monday: "7am - 8pm",
          Tuesday: "7am - 8pm",
          Wednesday: "7am - 8pm",
          Thursday: "7am - 8pm",
          Friday: "7am - 7pm",
          Saturday: "8am - 7pm",
          Sunday: "8am - 8pm"
        }
      },
      {
        id: 3, // not sure where this is relvant - from old school
        alias: 'mff-lake-oswego',
        name: 'My Fit Foods Lake Oswego',
        address: 'Kruse Village, 4835 Meadows Road #137, Lake Oswego, OR',
        hours: {
          Monday: "7am - 8pm",
          Tuesday: "7am - 8pm",
          Wednesday: "7am - 8pm",
          Thursday: "7am - 8pm",
          Friday: "7am - 7pm",
          Saturday: "8am - 7pm",
          Sunday: "8am - 8pm"
        }
      },
      {
        alias: 'mff-cedar-hills',
        name: 'My Fit Foods Cedar Hills',
        address: '3600 SW Cedar Hills Blvd., Beaverton, OR 97005',
        hours: {
          Monday: "7am - 8pm",
          Tuesday: "7am - 8pm",
          Wednesday: "7am - 8pm",
          Thursday: "7am - 8pm",
          Friday: "7am - 7pm",
          Saturday: "8am - 7pm",
          Sunday: "8am - 8pm"
        }
      }

    ],

    gym_locs: [
      {
        alias: 'pickup-salem',
        name: 'Crossfit Salem',
        address: '3589 Fairview Industrial Dr SE #100, Salem, OR 97302',
        hours: {
          Tuesday: "After 2pm",
        }
      },

    ],

    other_locs: [
      {
        alias: 'pickup-homewood',
        name: 'Homewood Suites',
        address: '701 SE Columbia Shores Blvd, Vancouver, WA 98661',
        hours: {
          Sunday: "After 9pm",
          Monday: "After 9pm",
        }
      },
      {
        alias: 'pickup-townplace',
        name: 'TownPlace Suites - Vancouver, WA',
        address: '17717 SE Mill Plain Blvd, Vancouver, WA 98683',
        hours: {
          Sunday: "After 9pm",
          Monday: "After 9pm",
        }
      },
    ],

  },


  texas: {
    time_zone: 'America/Chicago',
    time_zones: ['America/Chicago', 'America/New_York', 'America/Kentucky/Louisville', 'US/Central',
      'America/Kentucky/Monticello'],

    region_name: 'Texas',

    // delivery cut off time
    pickupPreorderCutoff: [
      [19, 59], // sunday
      [19, 59], // monday
      [19, 59], // tues
      [19, 59], // weds
      [19, 59], // thurs
      [18, 59], // fri
      [18, 59], // sat
    ],

    // sdd cut off time
    // make sure THIS COINCIDES WITH 3rd PARTY TIME WINDOWS
    mffDeliveryCutoff: [
      [16, 59], // sunday
      [16, 59], // monday
      [16, 59], // tues
      [16, 59], // weds
      [16, 59], // thurs
      [15, 59], // fri
      [15, 59], // sat
    ],

    satellitePickupCalendarOffset: [
      2, // sun
      2, // mon
      5, // tues
      4, // weds
      3, // thurs
      2, // fri
      2  // sat
    ],

    mff_locs: [
      {
        id: 5, // not sure where this is relvant - from old school
        alias: 'mff-houston',
        name: 'My Fit Foods Houston',
        address: '3239 SW Freeway, Houston, TX 77027',
        hours: {
          Monday: "7am - 8pm",
          Tuesday: "7am - 8pm",
          Wednesday: "7am - 8pm",
          Thursday: "7am - 8pm",
          Friday: "7am - 7pm",
          Saturday: "8am - 7pm",
          Sunday: "8am - 8pm"
        }
      },
      {
        id: 8,
        alias: 'mff-heights',
        name: 'My Fit Foods The Heights-Houston',
        address: '2802 N Shepherd Dr, #100, Houston, TX 77008',
        hours: {
          Monday: "7am - 8pm",
          Tuesday: "7am - 8pm",
          Wednesday: "7am - 8pm",
          Thursday: "7am - 8pm",
          Friday: "7am - 7pm",
          Saturday: "8am - 7pm",
          Sunday: "8am - 8pm"
        }
      },
      {
        alias: 'mff-sugarland',
        name: 'My Fit Foods Sugar Land',
        address: '2109 Highway 6 Suite B, Sugar Land, TX 77478',
        hours: {
          Monday: "7am - 8pm",
          Tuesday: "7am - 8pm",
          Wednesday: "7am - 8pm",
          Thursday: "7am - 8pm",
          Friday: "7am - 7pm",
          Saturday: "8am - 7pm",
          Sunday: "8am - 8pm"
        }
      },
      {
        alias: 'mff-bayarea',
        name: 'My Fit Foods Bay Area',
        address: '1065 W Bay Area Blvd. Suite 120, Bay Area, TX 77598',
        hours: {
          Monday: "7am - 8pm",
          Tuesday: "7am - 8pm",
          Wednesday: "7am - 8pm",
          Thursday: "7am - 8pm",
          Friday: "7am - 7pm",
          Saturday: "8am - 7pm",
          Sunday: "8am - 8pm"
        }
      }
    ],

    gym_locs: [
    ],

    other_locs: [
    ],
  }
};


// 2025 - be sure to subtract the output of this to convert from tz to utc and add to convert from utc to TZ
const getOffset = (timeZone = 'UTC', date = new Date()) => {
  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone }));
  return (tzDate.getTime() - utcDate.getTime()) / 6e4;
}



class CheckoutSelection {

  // 2025
  constructor() {
    const that = this;

    this.registerEventListeners();
    this.hideTimeGroup();


    // state/region selector
    $('#region-select-input').on('change', function(e) {
      e.preventDefault();
      that.region = $(this).val();
      if(window.localStorage) window.localStorage.setItem("region", $(this).val());

      that.switch_pickup_state();
    });
  }

  // 2025 - call once per initiate
  async getCart() {
    try {
      // if (this.cart) return this.cart; // remove cacheing. shopify is too slow

      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const json = await response.json();

      this.cart = json;
      this.cartTotal = this.cart.total_price;

      return this.cart;
    } catch (error) {
      console.error(error.message);
      return null;
    }
  }

  // 2025
  upperWord(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }


  // 2025
  generateShippingString(deliveryMethod, selectedDateStr, region, deliveryTime, pickupLocation) {

    const tz = deliveryLocByRegion[this.region].time_zone;
    const selectedDate = new Date(selectedDateStr);

    selectedDate.setMinutes(selectedDate.getMinutes() - getOffset(tz)); // picked is now selected tz at midnight

    var out_str = '';

    switch (deliveryMethod) {
      case delivery_methods.delivery:

        let day = 'Day';

        if(this.isToday(selectedDate)) day = 'Same Day';
        else if(this.isTomorrow(selectedDate)) day = 'Next Day';
        // if same day chosen, or next day, change the "day" string. not needed for third party
        // but doesn't hurt and is needed for mff fleet

        out_str += this.upperWord(region) + `, ${day}: ${selectedDateStr} | Time: ${deliveryTime}`;
        break;

      case delivery_methods.pickup:
      case delivery_methods.satellite_pickup:
        out_str += `Pickup  | Store: ${pickupLocation} | Day: ${selectedDateStr}`;
        break;
    }

    return out_str;
  }


  // 2025
  async gotoCheckout(deliveryMethod) {

    this.set_checkout_button_loading();

    const pickupLocation = $('.mff-modal--mff-location:checked').val();

    let address, encodedAddress = '', selectedDate;
    if(deliveryMethod == delivery_methods.pickup) {
      address = this.determinePickupAddress(pickupLocation);
      encodedAddress = this.encodeAddressToURLParams(address);
  
      selectedDate = $('#pickup-date-picker-container .mff-modal--date-picker-input').val();
    } else {
      selectedDate = $('#delivery-date-picker-container .mff-modal--date-picker-input').val();
    }

    const deliveryTime = $('.delivery-time-input:checked').val();
    const preciseDeliveryTime = $('.precise-delivery-time-input:checked').val();

    let time_to_use = deliveryTime;
    if($('#time-windows-third-party').is(':visible')) {
      time_to_use = preciseDeliveryTime;
    }

    const orderNote = this.generateShippingString(
      deliveryMethod,
      selectedDate,
      this.region,
      time_to_use,
      pickupLocation,
    );

    // console.log(orderNote);
    // return;

    const instructions = $('#driver-instructions').val();
    if(window.localStorage) window.localStorage.setItem('driver-instructions', instructions); // save for next time for customer

    const cart = await this.getCart();
    const cart_unique = cart.token.split('?')[0];
    const epochSeconds = Math.floor(Date.now() / 1000);

    let prev_params;
    try {
      prev_params = JSON.parse(localStorage.getItem('MFF_PPC'));
    } catch(e) {
      console.log("Failed retrieving ppc params", e);
    }

    try {
      const params = new URLSearchParams({
        cmd:'log-notes',
        cart_id:cart_unique,
        order_notes:orderNote,
        full_cart_id:cart.token,
        gclid:prev_params?.gclid || null,
        gbraid:prev_params?.gbraid || null,
        wbraid:prev_params?.wbraid || null,
        fbclid:prev_params?.fbclid || null
      });
      
      await fetch(`https://shop.myfitfoods.com/route?${params}`);
    } catch(e) {
      console.log("error setting cart notes", e);
    }

    try {
      // imperative to put notes on the first shippable item, or they will not be seen
      // by carrier api and order notes will be missing.

      let x;
      for(x = 0; x < cart.items.length; x ++ ) {
        if(cart.items[x].requires_shipping) {
          break; // need the first shippable item
        }
      }

      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: x + 1,
          quantity: cart.items[x].quantity,
          properties: {
            _orderNote: orderNote,
            _cartUniqueId: cart_unique,
            _driverInstructions: instructions,
            // _version: "20250602", // 6-2-2025
            _time: epochSeconds
          },
        }),
      });
    } catch(e) {
      console.log("error getting cart items", e);
    }

    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        note: orderNote,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        let signedUpForMarketing = false;
        if(window.localStorage) window.localStorage.getItem('mff-popup-status');
        let discount_string = '';

        if (
          typeof window.mff_discount !== 'undefined' &&
          typeof window.mff_discount.code !== 'undefined' &&
          window.mff_discount.already_applied === 'false'
        ) {
          const discount_code = window.mff_discount.code;

          if (discount_code) {
            discount_string = '&discount=' + discount_code;
            console.log('applying discount', discount_code);
          }
        }

        if (signedUpForMarketing === 'accepted') {
          const marketing_discount_code = '20OFFORDER';

          if (discount_string.includes('discount=')) {
            discount_string += ',' + marketing_discount_code;
          } else {
            discount_string = 'discount=' + marketing_discount_code;
          }
        }

        if(encodedAddress) {
          discount_string = '&' + discount_string;
        }

        // console.log(`/checkout?${encodedAddress}${discount_string}`, data);
        this.reset_checkout_button();
        window.location.href = `/checkout?${encodedAddress}${discount_string}`;
      });

      this.reset_checkout_button();
  }



  // 2025
  encodeAddressToURLParams(parsedAddress) {
    const params = new URLSearchParams();
    params.append('checkout[shipping_address][address1]', parsedAddress.street);
    params.append('checkout[shipping_address][city]', parsedAddress.city);
    params.append('checkout[shipping_address][province]', parsedAddress.state);
    params.append('checkout[shipping_address][country]', 'US');
    params.append('checkout[shipping_address][zip]', parsedAddress.zip);

    return params.toString();
  }

  // 2025
  parseAddress(address) {
    const parts = address.split(',').map((part) => part.trim());

    const parsedAddress = {
      street: '',
      city: '',
      state: '',
      zip: '',
    };

    if (parts.length < 3) {
      throw new Error('Address format is incorrect');
    }

    const cityStateZip = parts.pop().split(/\s+/);
    parsedAddress.city = parts.pop();

    if (cityStateZip.length >= 2) {
      parsedAddress.state = cityStateZip[0];
      parsedAddress.zip = cityStateZip.slice(1).join(' ');
    } else {
      parsedAddress.state = cityStateZip[0];
    }

    parsedAddress.street = parts.join(', ');

    return parsedAddress;
  }



  // 2025
  determinePickupAddress(pickupLocation) {
    for (const i in deliveryLocByRegion) {
      const regionObj = deliveryLocByRegion[i];
      const locationObj =
        regionObj.mff_locs.find((loc) => loc.name == pickupLocation) ||
        regionObj.gym_locs.find((loc) => loc.name == pickupLocation) ||
        regionObj.other_locs.find((loc) => loc.name == pickupLocation);

      if (locationObj) {
        const address = locationObj.address;
        return this.parseAddress(address);
      }
    }
  }



  // 2025
  registerEventListeners() {
    const that = this;

    document.querySelectorAll('.mff-modal--close-icon').forEach((icon) => {
      icon.addEventListener('click', () => {
        document.querySelectorAll('.mff-modal').forEach((modal) => {
          modal.classList.add('hidden');
        });
      });
    });


    // 2025
    document.querySelector('#delivery-available-pickup-button').addEventListener('click', () => {
      this.closeAllModals();
      document.querySelector('#delivery-available-modal').classList.add('hidden');
      document.querySelector('#pickup-selection-modal').classList.remove('hidden');
      document.querySelector('#pickup-selection-modal div[role="dialog"]').focus();
    });


    // 2025
    document.querySelector('#delivery-available-delivery-button').addEventListener('click', async () => {
      this.closeAllModals();

      document.querySelector('#delivery-selection-modal').classList.remove('hidden');
      document.querySelectorAll('.delivery-time-input');
      document.querySelector('#delivery-selection-modal div[role="dialog"]').focus();
    });


    // defaulting to chosen time so not needed
    // $('.delivery-time-input').on('change', function() {
    //   that.showCheckoutButton();
    // });


    // 2025 - switch to delivery
    document.querySelector('.mff-modal--delivery-redirect-link').addEventListener('click', () => {
      document.querySelector('#pickup-selection-modal').classList.add('hidden');
      document.querySelector('#delivery-selection-modal').classList.remove('hidden');
    });

    // 2025 - switch to pickup
    document.querySelector('.mff-modal--pickup-redirect-link').addEventListener('click', () => {
      document.querySelector('#delivery-selection-modal').classList.add('hidden');
      document.querySelector('#pickup-selection-modal').classList.remove('hidden');
    });


    // 2025
    document.querySelector('#mff-modal--pickup-checkout-button').addEventListener('click', async () => {
      // checkout in pickup
      this.gotoCheckout(delivery_methods.pickup);
    });

    // 2025
    document.querySelector('#delivery-selection-modal--checkout-btn').addEventListener('click', async () => {
      // checkout in delivery
      this.gotoCheckout(delivery_methods.delivery);
    });

  }


  // 2025
  disableBlockedDates(date) {
    const formattedFlatpickrDateToDisable = new Date(date).toISOString().slice(0, 10);
    return blockedDates2024.includes(formattedFlatpickrDateToDisable);
  }



  // 2025
  hideTimeGroup() {
    document.querySelector('#delivery-time-group').classList.add('hidden');
  }

  // 2025
  showTimeGroup(both) {
    document.querySelector('#delivery-time-group').classList.remove('hidden');
  }

  // 2025
  showCheckoutButton() {
    document.querySelector('#mff-modal--delivery-checkout-wrapper').classList.remove('hidden');
  }

  // 2025
  hideCheckoutButton() {
    document.querySelector('#mff-modal--delivery-checkout-wrapper').classList.add('hidden');
  }


  // 2025
  // holiday override - change this for days where stores open/close at abnormal
  // times. such as labor day. This affects 3rd party & pickup only
  checkHolidayOverrideTimes(date) {

    // labor day 3rd party hours
    // month is 0 ordinal. Date is 1 ordinal
    if(date.getMonth() == 8 && date.getDate() == 1) {
      return {
        '10am-1pm':10,
        '11am-2pm':11,
        '12pm-3pm':12,
        '3pm-6pm':15,
        '4pm-7pm':16,
        '5pm-8pm':17
      }
    }
  }

  // 2025
  // same as above but for pickup hours display
  checkHolidayOverridePickupTimes(date) {
    // labor day 3rd party hours
    // month is 0 ordinal. Date is 1 ordinal
    if(date.getMonth() == 8 && date.getDate() == 1) {
      return {
        'Labor Day': "10am - 8pm",
        Tuesday: "7am - 8pm",
        Wednesday: "7am - 8pm",
        Thursday: "7am - 8pm",
        Friday: "7am - 7pm",
        Saturday: "8am - 7pm",
        Sunday: "8am - 8pm"
      }
    }
  }


  // 2025
  checkCutoffDaily(delivery_method) {
    const tz = deliveryLocByRegion[this.region].time_zone;
    const currentMoment = new Date(); // localtime - need to convert to selected time zone

    currentMoment.setMinutes(currentMoment.getMinutes() - getOffset(this.tz)); // now its utc
    currentMoment.setMinutes(currentMoment.getMinutes() + getOffset(tz)); // now its selected tz

    const hours = currentMoment.getHours();
    const minutes = currentMoment.getMinutes();
    let day_of_week = currentMoment.getDay();

    var hourCutOff, minuteCutOff;

    // const is_sub_100_order = this.getCartTotalPrice() < (100*100);


    let cutoffDays;
    
    // 6.4.25 - no more min order for SDD - SDD is just the "first" available day and
    // where the overall cutoff begins
    if(delivery_method == delivery_methods.delivery /*&& !is_sub_100_order*/) {
    // just look at same day - cut off same day if we're passed cutoff. all other delivery days are open
      cutoffDays = deliveryLocByRegion[this.region].mffDeliveryCutoff;
    } else {
      cutoffDays = deliveryLocByRegion[this.region].pickupPreorderCutoff; // pickup/preorder cutoff
    }
    
    // cutoff is same for all delivery types now
    hourCutOff = cutoffDays[day_of_week][0];
    minuteCutOff = cutoffDays[day_of_week][1];

    // console.log(delivery_method, currentMoment, "hours", hours, "minutes", minutes, "day of week", day_of_week, 'hour cutoff', hourCutOff);

    var offset_date = 0;

    if (hours > hourCutOff) {
      day_of_week++;
      offset_date = 1;
    } else if (hours < hourCutOff) {
      // do nothing
      offset_date = 0;
    } else if (hours == hourCutOff) {
      if (minutes < minuteCutOff || minutes == minuteCutOff) {
        // do nothing
        offset_date = 0;
      } else if (minutes > minuteCutOff) {
        day_of_week++;
        offset_date = 1;
      }
    }
    if (day_of_week > 6) day_of_week = 0;

    switch (delivery_method) {
      case delivery_methods.satellite_pickup:
        const satellitePickupCalendarOffset = deliveryLocByRegion[this.region].satellitePickupCalendarOffset;

        currentMoment.setDate(currentMoment.getDate() + (offset_date + satellitePickupCalendarOffset[day_of_week]));
        return new Date(currentMoment.toDateString());

      case delivery_methods.pickup:
        currentMoment.setDate(currentMoment.getDate() + offset_date);
        return new Date(currentMoment.toDateString());

      case delivery_methods.delivery:
      default:

      // disable sub 100 - June 4, 2025
        // no same day/next day < $100 - add 2 days
        // if(is_sub_100_order) {
        //   // console.log("is a sub 100 order", this.getCartTotalPrice(), is_sub_100_order);
        //   offset_date += 2;
        // }

        currentMoment.setDate(currentMoment.getDate() + offset_date);
        return new Date(currentMoment.toDateString());
    }
  }


  // 2025
  getHour() {
    const tz = deliveryLocByRegion[this.region].time_zone;

    const today = new Date();
    today.setMinutes(today.getMinutes() - getOffset(this.tz)); // now its utc
    today.setMinutes(today.getMinutes() + getOffset(tz)); // now its selected tz


    return (
      today.getHours()
    );
  }


  // 2025
  isToday(dateToCheck) {
    const tz = deliveryLocByRegion[this.region].time_zone;

    const today = new Date();
    today.setMinutes(today.getMinutes() - getOffset(this.tz)); // now its utc
    today.setMinutes(today.getMinutes() + getOffset(tz)); // now its selected tz


    return (
      dateToCheck.getDate() === today.getDate() &&
      dateToCheck.getMonth() === today.getMonth() &&
      dateToCheck.getFullYear() === today.getFullYear()
    );
  }

  // 2025
  isTomorrow(dateToCheck) {
    const tz = deliveryLocByRegion[this.region].time_zone;

    const tomorrow = new Date();
    tomorrow.setMinutes(tomorrow.getMinutes() - getOffset(this.tz)); // now its utc
    tomorrow.setMinutes(tomorrow.getMinutes() + getOffset(tz)); // now its selected tz
    tomorrow.setDate(tomorrow.getDate() + 1);

    return (
      dateToCheck.getDate() === tomorrow.getDate() &&
      dateToCheck.getMonth() === tomorrow.getMonth() &&
      dateToCheck.getFullYear() === tomorrow.getFullYear()
    );
  }


  switch_pickup_state() {
    const regionData = deliveryLocByRegion[this.region];
    const tz = deliveryLocByRegion[this.region].time_zone;

    const that = this;

    const satellite_min_date = this.checkCutoffDaily(delivery_methods.satellite_pickup);


    document.querySelector('#mff-modal--mff-locations-insert').innerHTML = '';
    document.querySelector('#mff-modal--gym-locations-insert').innerHTML = '';
    document.querySelector('#mff-modal--other-locations-insert').innerHTML = '';

    document.querySelector('#pickup-warning-day').classList.add('hidden'); // hide the pickup warning day message
    document.querySelector('#pickup-selection-locations-wrapper').classList.remove('hidden');

    document.querySelector('#pickup-state-selector').classList.remove('hidden');

    document.querySelector('#mff-modal--pickup-checkout-wrapper').classList.add('hidden');

    const pickedDate = new Date(this.pickupDateStr); // utc
    pickedDate.setMinutes(pickedDate.getMinutes() - getOffset(tz)) // picked is now local date at midnight

    const disableInputs = () => {
      const otherLocs = document.querySelector('#mff-modal--other-locations'); // hiding the other locations
      const gymLocs = document.querySelector('#mff-modal--gym-locations'); // hiding the gym locations
      gymLocs.classList.add('disabled');
      otherLocs.classList.add('disabled');

      gymLocs.querySelectorAll('input').forEach((element) => {
        element.disabled = true;
      });
      otherLocs.querySelectorAll('input').forEach((element) => {
        element.disabled = true;
      });
      document.querySelector('#mff-modal--pickup-checkout-wrapper').classList.add('hidden');
    };

    const enableInputs = () => {
      const otherLocs = document.querySelector('#mff-modal--other-locations'); // hiding the other locations
      const gymLocs = document.querySelector('#mff-modal--gym-locations'); // hiding the gym locations
      gymLocs.classList.remove('disabled');
      otherLocs.classList.remove('disabled');

      gymLocs.querySelectorAll('input').forEach((element) => {
        element.disabled = false;
      });
      otherLocs.querySelectorAll('input').forEach((element) => {
        element.disabled = false;
      });
    };

    const generateRegionTemplate = (regionObj) => {

      let hours = regionObj.hours;

      const holiday_hours = that.checkHolidayOverridePickupTimes(pickedDate);
      if(holiday_hours) hours = holiday_hours;

      const hoursHtml = Object.entries(hours)
        .map(([day, hours]) => {
          return `<div><strong>${day}:</strong> ${hours}</div>`;
        })
        .join('');
      return `
      <div class="mff-modal--location-row" >
        <div class="mff-modal--location-row-header" >
          <div>
            <input type="radio" id="${regionObj.name.replace(/\s/g, "")}" value="${regionObj.name}" name="locations" class="mff-modal--mff-location" >
            <label for="${regionObj.name.replace(/\s/g, "")}">${regionObj.name}</label>
          </div>

          <div role="button" class="mff-modal--hours-wrapper" >
            hours
          </div>
        </div>


        <div class="mff-modal--location-hours-modal hidden " >
          <strong>
            ${regionObj.address}
          </strong>

          ${hoursHtml}

        </div>

      </div>
      `;
    };

    const locationHours = () => {
      // Query all .mff-modal--location-row elements
      const locationRows = document.querySelectorAll('.mff-modal--location-row');

      // Loop through each .mff-modal--location-row
      locationRows.forEach((row) => {
        // Find the .mff-modal--hours-wrapper within the current row
        const hoursWrapper = row.querySelectorAll('.mff-modal--hours-wrapper');

        hoursWrapper.forEach((hourElement) => {
          hourElement.addEventListener('click', () => {
            hourElement.parentNode.nextElementSibling.classList.toggle('hidden');
          });
        });
      });
    };

    regionData.mff_locs.map((loc) => {
      const regionTemplate = generateRegionTemplate(loc);
      document.querySelector('#mff-modal--mff-locations-insert').insertAdjacentHTML('beforeend', regionTemplate);
    });

    regionData.gym_locs.map((loc) => {
      const regionTemplate = generateRegionTemplate(loc);
      document.querySelector('#mff-modal--gym-locations-insert').insertAdjacentHTML('beforeend', regionTemplate);
    });

    regionData.other_locs.map((loc) => {
      const regionTemplate = generateRegionTemplate(loc);
      document.querySelector('#mff-modal--other-locations-insert').insertAdjacentHTML('beforeend', regionTemplate);
    });

    setTimeout(function() {
      let both_empty = 0;
      const gym_locs = document.querySelector('#mff-modal--gym-locations-insert');
      if(gym_locs.childNodes.length === 0) {
        document.querySelector('#mff-modal--gym-locations').classList.add('hidden');
        both_empty ++;
      }

      const priv_locs = document.querySelector('#mff-modal--other-locations-insert');
      if(priv_locs.childNodes.length === 0) {
        document.querySelector('#mff-modal--other-locations').classList.add('hidden');
        both_empty ++;
      }

      if(both_empty > 1) {
        document.querySelector('#pickup-warning').classList.add('hidden');
        document.querySelector('#pickup-warning-day').classList.add('hidden');
      }
    });

    document.querySelectorAll('.mff-modal--mff-location').forEach((element) => {
      element.addEventListener('click', (e) => {
        document.querySelector('#mff-modal--pickup-checkout-wrapper').classList.remove('hidden');
      });
    });

    locationHours();
    // by default, rendering all locations
    document.querySelector('#mff-modal--mff-locations').classList.remove('hidden'); // showing all MFF locations
    document.querySelector('#mff-modal--gym-locations').classList.remove('hidden'); // showing all gym locations
    document.querySelector('#mff-modal--other-locations').classList.remove('hidden'); // showing all other locations

    document.querySelector('#pickup-warning').innerHTML =
      `Sorry, the first available date for Gym and Private Location pickup is ${satellite_min_date.toDateString()}`; // adding HTML to error message (element is hidden until this stage)

    const convertedDate = new Date(satellite_min_date);
    convertedDate.setMinutes(convertedDate.getMinutes() + getOffset(tz));
    
    if (pickedDate < convertedDate) {
      // Date is before the minimum date, make gyms and other locations unavailable
      // not available
      // unselect gym and others
      document.querySelector('#pickup-warning').classList.remove('hidden'); // showing the pickup warning message
      document.querySelector('#pickup-warning-day').classList.add('hidden');
      disableInputs();
    } else {
      // date is after or on the minimum date, make the gyms and other locations available
      document.querySelector('#mff-modal--other-locations').classList.remove('hidden'); // show the other locations
      document.querySelector('#mff-modal--gym-locations').classList.remove('hidden'); // show the gym locations
      enableInputs();
      if (this.pickupDateStr) {
        // if selected date is available
        const day_num = pickedDate.getDay(); // get the numerical day of the week
        
        // disable thurs, fri, sat
        if (day_num != 0 && day_num != 1 && day_num != 2 && day_num != 3) {
          // if it's a thurs, fri, sat
          // not a delivery date, show the warning
          document.querySelector('#pickup-warning').classList.add('hidden'); // show the pickup warning
          document.querySelector('#pickup-warning-day').classList.remove('hidden'); // show the pickup warning day message
          disableInputs();
        } else {
          document.querySelector('#pickup-warning').classList.add('hidden'); // hide the pickup warning
          document.querySelector('#mff-modal--other-locations').classList.remove('hidden'); // show the other locations
          document.querySelector('#mff-modal--gym-locations').classList.remove('hidden'); // show the gym locations
          enableInputs();
        }
      }
    }
  }


  // 2025
  async initCalendars(param_region) {
    const tz = deliveryLocByRegion[this.region].time_zone;
    const that = this;

    // reset calendars
    if (this.pickupCalendar) {
      // this.deliveryCalendar.clear();
      this.pickupCalendar.destroy();
    }
    if (this.deliveryCalendar) {
      // this.deliveryCalendar.clear();
      this.deliveryCalendar.destroy();
    }

    this.pickupCalendar = flatpickr('#pickup-date-selector', {
      minDate: this.checkCutoffDaily(delivery_methods.pickup),
      disable: [this.disableBlockedDates],
      altInput: true,
      altFormat: 'F j, Y',
      onChange: function (_selectedDates, dateStr, _instance) {
        that.pickupDateStr = dateStr; // chosen pickup date
        that.switch_pickup_state();
      },
      onReady: (a, b, fp) => {
        try {
          fp.altInput.setAttribute('aria-label', 'choose pickup date');
        } catch (e) { }
      },
      onDayCreate: function (dObj, dStr, fp, dayElem) {
        try {
          const today = new Date();
          const dayDate = new Date(dayElem.getAttribute('aria-label'));
          const dateString = dayDate.getFullYear() + '-' + (dayDate.getMonth() + 1) + '-' + dayDate.getDate();

          if (blockedDates2024.includes(dateString) || dayDate < today) {
            dayElem.setAttribute('aria-hidden', 'true')
          } else {
            dayElem.setAttribute('role', 'button')
          }
        } catch (e) { }
      }
    });





    // delivery calendar
    this.deliveryCalendar = flatpickr('#delivery-date-selector', {
      minDate: this.checkCutoffDaily(delivery_methods.delivery),
      disable: [this.disableBlockedDates],
      altInput: true,
      altFormat: 'F j, Y',
      onChange: function (selectedDates, dateStr, instance) {
        // for deliveries - take a look at day chosen
        // same day - only offer afternoon hours. and cut off at 3pm
        
        // if same day hide morning
        const pickedDate = new Date(dateStr); // utc

        pickedDate.setMinutes(pickedDate.getMinutes() - getOffset(tz)) // picked is now selected tz at midnight
        let day_of_week = pickedDate.getDay();
        let hour = that.getHour(); // current local hour

  
        // dynamically build precise time windows
        let times = third_party_time_windows[day_of_week];

        // console.log(times, that.region, that.tz, tz, pickedDate);

        // check if holiday override - local time zone
        const holiday_times = that.checkHolidayOverrideTimes(pickedDate);
        if(holiday_times) times = holiday_times;

        $('#time-windows-third-party').empty();
        for(const tm in times) {
          const upper_time = tm.toUpperCase();
          let time_window = `<div class="time-window-row" data-max-hour="${times[tm]}">
          <input type="radio" class="precise-delivery-time-input" id="tw-${tm}" value="${upper_time}" name="time-window-tp">
          <label for="tw-${tm}">${tm}</label>
          </div>`;
          $('#time-windows-third-party').append(time_window);
        }
        
        // check if picked date = today/tomorrow (sdd/ndd)
        // or Tues / Thurs / Friday
        // or any exclusive 3rd party day - use the new time windows
        // otherwise use blocks for MFF Fleet
        if(that.isToday(pickedDate) || that.isTomorrow(pickedDate) || day_of_week == 2 || (day_of_week >= 4 && day_of_week <= 6)) {
          let first_one_selected = false;

          // show available time blocks dynamically
          if(that.isToday(pickedDate)) {
            
            $('.time-window-row').each(function(e) {
              const cutoff_hour = $(this).attr('data-max-hour');
              if(hour >= cutoff_hour) {
                $(this).hide();
              } else {
                $(this).show();
                if(!first_one_selected) {
                  $(this).find('input').first().prop('checked', true);
                  first_one_selected = true;
                }
              }
            });
          } else {
            $('.time-window-row').each(function(e) {
              $(this).show();
              if(!first_one_selected) {
                $(this).find('input').first().prop('checked', true);
                first_one_selected = true;
              }
            });
          }

          $('#time-windows-mff').hide();
          $('#time-windows-third-party').show();
        } else {
          // $('.delivery-time-label').show(); // show all times
          // $('.delivery-time-input').show(); // show all times
          
          $('#time-windows-mff').show();
          $('#time-windows-third-party').hide();
        }


        that.showTimeGroup();
        that.showCheckoutButton();
      },
      onReady: (a, b, fp) => {
        try {
          fp.altInput.setAttribute('aria-label', 'choose delivery date');
        } catch (e) { }
      },
      onDayCreate: function (dObj, dStr, fp, dayElem) {
        try {
          const today = new Date();
          const dayDate = new Date(dayElem.getAttribute('aria-label'));
          const dateString = dayDate.getFullYear() + '-' + (dayDate.getMonth() + 1) + '-' + dayDate.getDate();

          if (blockedDates2024.includes(dateString) || dayDate < today) {
            dayElem.setAttribute('aria-hidden', 'true')
          } else {
            dayElem.setAttribute('role', 'button')
          }
        } catch (e) { }
      }
    });
  }





  // 2025
  closeAllModals() {
    document.querySelector('#delivery-selection-modal').classList.add('hidden');
    document.querySelector('#pickup-selection-modal').classList.add('hidden');
    document.querySelector('#delivery-available-modal').classList.add('hidden');
    document.querySelector('#products-not-shippable-modal').classList.add('hidden');
  }


  // 2025
  getCartTotalPrice() {
    return this.cartTotal;
  }


  // 2025
  async openDeliveryOptions() {
    this.closeAllModals();

    // WOT baby
    const modal = document.querySelector('#delivery-available-modal');
    modal.classList.remove('hidden'); // open this for pickup and delivery
    modal.querySelector(".mff-modal--close-icon").focus();

    this.initCalendars();
  }


  // 2025
  needsDeliveryModal(cart) {
    var eligible = false;

    try {
      const line_items = this.cart.items;
      line_items.forEach((line_item) => {
        if(!line_item.title.includes('Fit Club') &&
          !line_item.title.includes('Gift Card')
        ) {
          eligible = true;
        }
      });
    } catch (e) {
      // silent fail, it will just always show zip modal
      eligible = true;
    }
    return eligible;
  }


  // 2025
  set_checkout_button_loading() {
    $('#delivery-selection-modal--checkout-btn').html(`
    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
    <span role="status">LOADING...</span>
    `).attr('disabled','disabled');
  }

  // 2025
  reset_checkout_button() {
    $('#delivery-selection-modal--checkout-btn').text('Continue To Checkout').removeAttr('disabled');
  }


  // 2025
  async initiate() {

    // browser timezone

    this.tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    for (const dl in deliveryLocByRegion) {
      if (deliveryLocByRegion[dl].time_zones.includes(this.tz)) {
        // our chosen state
        this.region = dl;
        console.log("chosen region is ", this.region);
      }
    }

    // default for all other tz's
    if(window.localStorage && window.localStorage.getItem("region")) this.region = window.localStorage.getItem("region");
    if (!this.region) this.region = 'texas';


    $('#region-select-input').val(this.region);


    // find the nearest tz. if not found, default to central

    if(window.localStorage) $('#driver-instructions').val(window.localStorage.getItem('driver-instructions'));

    this.reset_checkout_button();

    // this.cart = null;
    // this.cartTotal = null;

    const cart = await this.getCart();

    if (!this.needsDeliveryModal(cart)) {
      // note - not applying discount code
      // not needed for fit club or gift card only
      // but may need to be expanded later
      window.location.href = `/checkout`;
      return;
    }


// have to force cart to load again in case there is a pending
// add to cart which takes a long period
    // this.cart = null;
    // this.cartTotal = null;

    this.openDeliveryOptions();
  }
}

// 2025
document.addEventListener('DOMContentLoaded', function () {

  // global
  window.checkoutSelection = new CheckoutSelection();

  // 2025 - register checkout cta click to initiate cart and drawer
  $('.cart__ctas button').off('click').on('click', function (e) {
    e.preventDefault();
    window.checkoutSelection.initiate();
  });

});